import React, { useEffect } from 'react';

import AOS from "aos";
import "aos/dist/aos.css";

function Header() {

  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div id="home">
      <div>
        <h2 data-aos-easing='ease-in-quad' data-aos-duration='500' data-aos='fade-up'>
          Hi, I'm Tolu.
        </h2>

        <h4 data-aos-easing='ease-in-quad' data-aos-duration='700' data-aos='fade-up'>
          I Create <span className="bold">Web</span> Solutions.
        </h4>
        <h4 data-aos-easing='ease-in-quad' data-aos-duration='900' data-aos='fade-up'>
          I Bring Designs to <span className="bold">Life.</span>

        </h4>
        <h4 data-aos-easing='ease-in-quad' data-aos-duration='1100' data-aos='fade-up'>

          I Am A <span className="bold">Frontend</span> Developer.
        </h4>

        <p data-aos-easing='ease-in-quad' data-aos-duration='1300' data-aos='fade-up'>
          A detail-oriented, self-starting frontend developer with a year experience in building and developing responsive, functional and mobile-first sites.
        </p>
      </div>



    </div>

  );
}

export default Header;
